(() => {
  'use strict';
  if(window.LXPurchaseGuardInstalled)return;
  let marker = document.querySelector('[data-lx-shared-flow-marker]');
  let root = document.querySelector('.main-product product-info');
  if (!marker || !root || root.hasAttribute('data-lx-purchase-guard')) return;
  root.setAttribute('data-lx-purchase-guard', '');
  window.LXPurchaseGuardInstalled=true;
  let copy = marker.dataset;
  const refreshRoot=()=>{
    root=document.querySelector('.main-product product-info');
    marker=document.querySelector('[data-lx-shared-flow-marker]');
    if(!root||!marker)return false;
    copy=marker.dataset;root.setAttribute('data-lx-purchase-guard','');return true;
  };
  let pending = 0;
  const form = () => root.querySelector('product-form form[action*="/cart/add"]');
  const originalButton = () => form()?.querySelector('button[name="add"]');
  const status = document.createElement('p');
  status.className = 'lx-purchase-status'; status.setAttribute('role','status');
  const show = (text, error = false) => {
    const button = originalButton();
    if (button && status.nextElementSibling !== button) button.before(status);
    if (status.textContent !== text) status.textContent = text;
    status.toggleAttribute('data-error', error);
  };
  const guard = () => {
    if (pending) { show(copy.busy); return false; }
    if (window.LXPurchaseReadiness && !window.LXPurchaseReadiness.ready(root)) { show(copy.quotePending); return false; }
    if (root.hasAttribute('data-lx-restoring') || root.hasAttribute('data-lx-restore-failed')) {
      document.getElementById('LXLocaleNotice')?.focus(); return false;
    }
    if (root.querySelector('.image-upload .ant-spin-spinning,.image-upload [aria-busy="true"]')) { show(copy.uploading); return false; }
    const quantity = root.querySelector('input[name="quantity"][form]');
    if (quantity && (!quantity.value.trim() || !Number.isSafeInteger(Number(quantity.value)) || Number(quantity.value) < 1 || !quantity.validity.valid)) {
      show(copy.quantity, true); quantity.focus(); quantity.reportValidity(); return false;
    }
    const empty = [...root.querySelectorAll('[data-lx-app-content] [id$="image-swatch"]')].find(field => field.querySelector('.custom-required') && !field.querySelector('.c-active-option'));
    if (empty) {
      root.querySelector('lx-mobile-customization')?.reveal?.();
      empty.setAttribute('data-lx-invalid','');
      let error = empty.querySelector('.lx-accessory-error');
      if (!error) { error = document.createElement('p'); error.className = 'lx-accessory-error'; error.setAttribute('role','alert'); empty.prepend(error); }
      error.textContent = copy.error; empty.tabIndex = -1; empty.scrollIntoView({block:'center'}); empty.focus({preventScroll:true}); return false;
    }
    show(''); return true;
  };
  document.addEventListener('click', event => {
    if(!refreshRoot())return;
    const button = event.target instanceof Element ? event.target.closest('button,input[type="submit"]') : null;
    if (!button || button.disabled) return;
    const purchase = button === originalButton() || button.matches('.lxmp-action,.lxdp-action') || (root.contains(button) && button.closest('#shopaw-container-block,#shopaw-container') && /^(add to cart|buy)/i.test(button.textContent.trim()));
    if (purchase && !guard()) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
  document.addEventListener('submit', event => {
    if(!refreshRoot())return;
    if (event.target === form() && !guard()) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
  const targeted = (method,url) => {
    try { const u = new URL(url,location.origin); return String(method).toUpperCase()==='POST' && u.origin===location.origin && /\/cart\/add(?:\.js)?\/?$/.test(u.pathname); } catch (_) { return false; }
  };
  function start() {
    if(!refreshRoot())return ()=>{};
    pending++; root.setAttribute('data-lx-cart-pending',''); show(copy.busy);
    root.dispatchEvent(new Event('change',{bubbles:true}));
    let done = false;
    return () => {
      if (done) return; done = true; pending = Math.max(0,pending-1);
      if (!pending) { root.removeAttribute('data-lx-cart-pending'); show(''); }
      root.dispatchEvent(new Event('change',{bubbles:true}));
    };
  }
  if (typeof XMLHttpRequest === 'function') {
    const proto = XMLHttpRequest.prototype, open = proto.open, send = proto.send;
    const tracked = new WeakMap();
    proto.open = function(method,url,...rest) { const result=open.call(this,method,url,...rest); tracked.set(this,targeted(method,url)); return result; };
    proto.send = function(...args) {
      if (!tracked.get(this)) return send.apply(this,args);
      const finish=start(); const end=()=>{this.removeEventListener('loadend',end);finish();};
      this.addEventListener('loadend',end);
      try { return send.apply(this,args); } catch(error) { end(); throw error; }
    };
  }
  if (typeof window.fetch === 'function') {
    const fetch = window.fetch;
    window.fetch = function(input,init) {
      const isRequest = typeof Request === 'function' && input instanceof Request;
      if (!targeted(init?.method || (isRequest ? input.method : 'GET'),isRequest ? input.url : input)) return fetch.apply(this,arguments);
      const finish=start();
      try { const promise=fetch.apply(this,arguments); promise.then(finish,finish); return promise; } catch(error) { finish(); throw error; }
    };
  }
})();
